import { render, staticRenderFns } from "./RecoverAccountView.vue?vue&type=template&id=7b641c04&scoped=true"
import script from "./RecoverAccountView.vue?vue&type=script&lang=ts"
export * from "./RecoverAccountView.vue?vue&type=script&lang=ts"
import style0 from "./RecoverAccountView.vue?vue&type=style&index=0&id=7b641c04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b641c04",
  null
  
)

export default component.exports